import React from 'react'
import { classToDOMCard } from 'react-mobiledoc-editor'

class Divider extends React.Component {
  static displayName = 'Divider'

  render () {
    return <hr />
  }
}

export default classToDOMCard(Divider)



// WEBPACK FOOTER //
// ./app/components/editor/cards/Divider.js